
export const isLikelyLocation = (text: string, currentDeployLoc: string = '', currentDiscLoc: string = ''): boolean => {
  if (!text || text.length < 3) return false;
  const lower = text.toLowerCase().trim();
  
  // Check common location keywords (extended)
  const locationKeywords = [
    'street', 'road', 'ave', 'boulevard', 'blvd', 'lane', 'ln', 'drive', 'dr', 'court', 'ct', 
    'city', 'town', 'country', 'district', 'neighborhood', 'province', 'state', 'region', 
    'block', 'square', 'plaza', 'mall', 'building', 'tower', 'center', 'centre',
    'village', 'capital', 'county', 'territory', 'municipality'
  ];
  
  // Patterns indicative of location entries
  const hasComma = lower.includes(',');
  const hasGeoPreposition = /\bin\s+[a-z]/i.test(lower) || /\bnear\s+[a-z]/i.test(lower) || /\bat\s+[a-z]/i.test(lower);
  const hasKeyword = locationKeywords.some(k => lower.includes(k));
  
  // Check against current selected location (Cross-Hub Sensitivity)
  const isMatched = (currentDeployLoc && lower.includes(currentDeployLoc.toLowerCase())) || (currentDiscLoc && lower.includes(currentDiscLoc.toLowerCase()));

  // Major global cities check
  const majorCities = ['london', 'new york', 'tokyo', 'paris', 'berlin', 'kampala', 'nairobi', 'lagos', 'dubai', 'singapore', 'sydney', 'mumbai'];
  const isMajorCity = majorCities.some(c => lower.includes(c));

  // Avoid false positives for "Mall" or "Center" in common business names if they have enough non-geo words
  if (lower.split(' ').length > 4) {
    return hasGeoPreposition || hasComma;
  }

  return hasKeyword || isMatched || isMajorCity || hasComma;
};
